import { Address } from "../../../models";
import { DEPENDENT_FIELDS_MAP } from "../constants";
import { AddressFieldType } from "../types";

const getDependentFieldsToClear = (
  fieldType: AddressFieldType
): (keyof Address)[] => {
  return DEPENDENT_FIELDS_MAP[fieldType];
};

export const clearDependentFields = (
  address: Address,
  fieldType: AddressFieldType
): Partial<Address> => {
  const fieldsToClear = getDependentFieldsToClear(fieldType);
  const clearedFields = fieldsToClear.reduce(
    (acc, field) => ({
      ...acc,
      [field]: typeof address[field] === "string" ? "" : undefined,
    }),
    {}
  );

  return clearedFields;
};
